import { httpClient } from './client';

export type ShipmentTopupTier = {
  quantity: number;
  price: number;
};

/**
 * Fetch purchasable adhoc shipment-label top-up tiers (e.g. "100 Labels $19.99").
 * Distinct from `SubscriptionLimit.tiers` in manage-subscription.api, which describes
 * plan-upgrade volume tiers rather than one-off top-up SKUs. Currency is assumed to be seller subscription currency.
 */
export const getShipmentTopUpTiers = async (): Promise<ShipmentTopupTier[]> => {
  const response = await httpClient.get('/account/purchaseVolume/reference');
  return response.data;
};
